import Badge from '../Badge/Badge';
import Show from '../Show/Show';
import { ActivityInfo, ActivityType } from '../ActivityInfo/ActivityInfo';
import { GRADIENTS, ModuleGradient } from '../../config/designSystem/Colors';
import { SPACING } from '../../config/designSystem/Spacing';
import { View } from 'react-native';
import { observer } from 'mobx-react';
import { useMaxWidthForBadge } from './useMaxWidthForBadge';
import { useStores } from '../../hooks/useStores';

export type BadgeAndActivityProps = {
    pathId?: string,
    type: ActivityType
}

const _BadgeAndActivity = ({pathId, type}: BadgeAndActivityProps) => {
  const rootStore = useStores();
  const maxWidthForBadge= useMaxWidthForBadge();
  if(!pathId) return null;
  const path = rootStore?.path.getPath(pathId);
  const category = rootStore?.path.getCategory(pathId);

  const colorForBadge = (GRADIENTS.modules[path?.designSystemColor|| 'YELLOW'] as ModuleGradient).base;

  return(<View style={{flexDirection:'row', columnGap: SPACING['sp-12'], alignItems: 'center'}}>
    <Show when={!!category && !!path}>
      <View style={{maxWidth: maxWidthForBadge}}>
        <Badge leftColor={colorForBadge.left} rightColor={colorForBadge.right} label={category?.shortTitle || category?.title || ''} />
      </View>
    </Show>
    <ActivityInfo type={type} />
  </View>);
};

export const BadgeAndActivity= observer(_BadgeAndActivity);